import { MEMBER_CATEGORIES } from "@/lib/memberCategory";
import { Star, Wrench, Video } from "lucide-react";

const CATEGORY_ICON = { founding_member: Star, sim_racing_expert: Wrench, content_creator: Video };

// Compact membership badge shown next to a user's name on posts.
export default function MemberBadge({ memberCategory, isFounding, className = "", testId }) {
  const key = memberCategory && MEMBER_CATEGORIES[memberCategory]
    ? memberCategory
    : isFounding
    ? "founding_member"
    : "";
  if (!key) return null;
  const meta = MEMBER_CATEGORIES[key];
  const Icon = CATEGORY_ICON[key];
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold ${meta.badgeClass} ${className}`}
    >
      {Icon && <Icon className="h-2.5 w-2.5" />}
      {meta.label}
    </span>
  );
}
